import axios from 'axios';

export interface Author {
    id: string;
    name: string;
    additionalInfo?: AuthorAdditionalInfo;
}

export interface AuthorAdditionalInfo {
    authorId: string;
    name: string;
    url?: string;
    paperCount?: number;
    citationCount?: number;
    affiliations: string[];
    hIndex?: number;
    personaIdx?: string;
    task?: string[];
    method?: string[];
}

export function getAuthorInfo(authorId: string, year: string): Promise<AuthorAdditionalInfo> {
    return axios
        .get(`/api/get_author_info/${authorId}`, { params: { year: year } })
        .then((response) => response.data);
}
